function n(n,e){-1===n.indexOf(e)&&n.push(e)}export{n as addUniqueItem};
